import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { Button, Icon } from 'antd';
import {connect} from 'react-redux';
import {fetchAdmins} from '../../actions';
import PaginatedList from '../PaginatedList';

class Admins extends Component {
    render() {
        const {fetchAdmins, admins, landlord, match, location: {search}} = this.props;
        const columns = [{
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <span>
                    <Link to={{
                        pathname: `${match.url}/${record.id}/edit`,
                        state: {
                            from: search || 'page=1'
                        }
                    }}>{text}</Link>
                </span>
            )
        }, {
            title: 'Job Title',
            dataIndex: 'job_title',
            key: 'job_title'
        }, {
            title: 'Branch Location',
            dataIndex: 'branch_location',
            key: 'branch_location',
            render: (text, record) => {
                return record.branch.branch_name;
            }
        }, {
            title: 'Email',
            dataIndex: 'email',
            key: 'email'
        }, {
            title: 'Phone Number',
            dataIndex: 'phone_number',
            key: 'phone_number'
        }, {
            title: 'Permissions',
            key: 'permissions',
            render: () => 'ALL'
        }];

        const fetch = (id) => {
            return fetchAdmins(landlord, id);
        };
        return (
            <div>
                <Button style={{marginBottom: 10}} type="primary">
                    <Link to={`${match.url}/new`}><Icon type="plus"/> New</Link>
                </Button>
                <PaginatedList
                    fetchData={fetch}
                    columns={columns}
                    source={admins}
                    {...this.props}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const admins = state.landlord.admins;
    return {
        landlord: state.me.application.id,
        admins: [...admins.data],
        meta: admins.meta,
        loading: admins.isFetching,
    };
};

export default connect(mapStateToProps, {fetchAdmins})(Admins);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/Admins.js